import styled from 'styled-components';

export const LandingPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding-bottom: 5%;
    margin-left:6%;
    margin-right:6%;

    @media only screen and (max-width: 600px) {
       margin-top: 55vh;
       top: 0;
       body {
        align-items: flex-start;
       }
    }
`;

export const LandingPageInternal = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 100vh;
    margin: 5% 5%;
`;

export const LandingPageTitle = styled.h1`
    font-size: 5rem;
    color: ${props => props.theme.evTeal};
`;

export const LandingPageParagraph = styled.div`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    // width: 75%;
    text-align: left;

    div {
    margin: 1rem 0;
    }

    b {
    font-weight: bold;
    color: ${props => props.theme.evTeal};
    }

    i {
    font-style: italic;
    font-size: 0.75rem;
    }

`;

export const Logo = styled.img`
    width: auto;
    height: 20%;
    padding: 1rem;

    &:hover {
        cursor: pointer;
    }
`;

export const MainButton = styled.button`
    background-color: ${props => props.theme.evTeal};
    color: white;
    border: none;
    padding: 1rem 2rem;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1.5rem;

    &:hover {
        background-color: ${props => props.theme.eLime};
    }
`;
